const CLIENT_ID = process.env.VUE_APP_CLIENT_ID
const apiUrl = "/api"
const wrikeAuthUrl = "https://login.wrike.com/oauth2/authorize/v4?client_id=" + CLIENT_ID + "&response_type=code&scope=Default,wsReadWrite&redirect_uri="+window.location.origin+"/auth"
import router from './router'
import moment from 'moment'


function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

async function processData(method, url, data){
    let options = { method, headers: { Token: localStorage.getItem('apiKey') } }
    if(data) {
        options.body = JSON.stringify(data)
        options.headers['Content-Type'] = 'application/json'
    }

    let result = await fetch(apiUrl + url, options)

    if (result.status == 401) router.push('/login')

    if (result.status < 400) return result.json()
    else {
        console.error("Failed API call: " + url, Error(result.statusText))
        await sleep(1000)
        return await processData(method, url, data)
    }
}

const api = {
    async GET(url) {
        if(localStorage.getItem(url)){
            let data = JSON.parse(localStorage.getItem(url))
            return Promise.resolve(data)
        }else{
            return processData('get', url).then(data => {
                data.loaded = moment().format("DD.MM.YYYY HH:mm:ss")
                if(shouldCacheUrl(url)) localStorage.setItem(url, JSON.stringify(data))
                return data
            })
        }
    },
    async PUT(url, data) {
        return processData('put', url, data)
    },
    async DELETE(url) {
        return processData('delete', url)
    },
    async POST(url, data) {
        return processData('post', url, data)
    }
}

function shouldRemoveChachedKey(url){
    return url.startsWith('/tasks/') || url.startsWith('/hours') || url.startsWith('/teams/mine') || url.startsWith('/invoice')
}

function shouldCacheUrl(url){
    return url.startsWith('/hours') || url.startsWith('/teams/mine') || url.startsWith('/invoice')
}

export {api, apiUrl, wrikeAuthUrl, shouldCacheUrl, shouldRemoveChachedKey}
export default api